module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "list list-box p0002"
  }, [_c('dmenu', {
    attrs: {
      "name": "Alert"
    },
    on: {
      "on-switch": _vm.alert
    }
  }), _vm._v(" "), _c('dmenu', {
    attrs: {
      "name": "Confirm"
    },
    on: {
      "on-switch": _vm.confirm
    }
  }), _vm._v(" "), _c('dmenu', {
    attrs: {
      "name": "Has child components"
    },
    on: {
      "on-switch": function($event) {
        _vm.show2 = true
      }
    }
  }), _vm._v(" "), _c('dmenu', {
    attrs: {
      "name": "全局调用"
    },
    on: {
      "on-switch": _vm.open
    }
  })], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "show": _vm.show,
      "type": _vm.type
    },
    on: {
      "on-confirm": function($event) {
        _vm.show = false
      },
      "on-cancel": function($event) {
        _vm.show = false
      }
    }
  }, [_vm._v("Hello world!")]), _vm._v(" "), _c('modal', {
    attrs: {
      "show": _vm.show2,
      "type": _vm.type
    },
    on: {
      "on-confirm": function($event) {
        _vm.show2 = false
      },
      "on-cancel": function($event) {
        _vm.show2 = false
      }
    }
  }, [_c('input', {
    staticClass: "input form-control",
    attrs: {
      "type": "text",
      "name": "name",
      "placeholder": "请输入"
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5ca07faf!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/demo.vue
// module id = 255
// module chunks = 18